// File: src/components/Header.jsx

import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/logo.png";
import "../styles/components/Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef();
  const { user } = useAuth();
  const location = useLocation();

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  // Close menu if clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Auto-close on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="header">
      <div className="left-section">
        {user && (
          <div className="user-info">
            <span>
              {user.USER_NAME} {user.USER_SURNAME}
            </span>
            <span className="user-role">{user.ROLE_NAME}</span>
          </div>
        )}
      </div>

      <div className="right-section">
        <img
          src={logo}
          alt="Menu"
          className="menu-icon"
          onClick={toggleMenu}
        />
        <nav className={`nav-menu ${menuOpen ? "open" : ""}`} ref={menuRef}>
          <Link to="/dashboard">Dashboard</Link>
          {user?.ROLE_NAME === "Admin" && <Link to="/admin">Admin</Link>}
          <Link to="/logout">Logout</Link>
        </nav>
      </div>
    </header>
  );
}
